import { useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import { TopBarContext } from "context/TopBarContext";

/**
 * Put a page's own content into the dashboard top bar (see TopBarContext). Both
 * render nothing outside the dashboard; callers that can also run there check
 * `useContext(TopBarContext)` and lay themselves out instead.
 */
export const TopBarTitle = ({ children }) => {
  const topBar = useContext(TopBarContext);
  useEffect(() => topBar?.register(), [topBar]);
  return topBar?.titleNode ? createPortal(children, topBar.titleNode) : null;
};

export const TopBarActions = ({ children }) => {
  const topBar = useContext(TopBarContext);
  const filled = Boolean(children);
  useEffect(() => (filled ? topBar?.register() : undefined), [topBar, filled]);
  return topBar?.actionsNode && children
    ? createPortal(children, topBar.actionsNode)
    : null;
};
